import { useState } from 'react';
import { useConnect } from '@lore/query-connect';
import queryString from 'query-string';
import moment from 'moment-timezone';
import useStewardshipFilter from '@/pages/projects/useStewardshipFilter';
import getQueryUtils, { attributeKeys } from '@/pages/projects/queryUtils';
import REQUIRED_FIELDS_PAST from '@/pages/projects/REQUIRED_FIELDS_PAST';
import { MISSING_FIELDS_$AGGREGATIONS } from '@/pages/projects/MISSING_FIELDS';

export default function useQuery(props) {
  const {
    search = {},
    pageSize = 4
  } = props;

  const [timestamp] = useState(moment().toISOString());
  const stewardshipFilter = useStewardshipFilter();

  const queryUtils = getQueryUtils(search, attributeKeys, timestamp);

  return useConnect('project.find', {
    where: {
      eager: {
        $aggregations: MISSING_FIELDS_$AGGREGATIONS,
        $where: {
          // $and: REQUIRED_FIELDS_PAST.$and,
          $and: [
            ...REQUIRED_FIELDS_PAST.$and,
            // ...queryUtils.where
          ],
          activityId: {
            $null: false
          },
          $or: stewardshipFilter,
          completed:true
        },
        $having: {
          $and: [...queryUtils.having]
        }
      }
    },
    pagination: {
      page: queryString.parse(location.search).page || '1',
      pageSize: pageSize,
      order: search.order || 'createdAt desc'
    }
  }, {
    keepPreviousData : true
  });
}
